import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Container,
  Input,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import { connect } from 'react-redux';
import { ITokenTable, ITokenTableRedux, ITarget } from '../../types/interfaces';

import TokenEdit from './TokenEdit';
import TableContainer from "../tables_manager/TableContainer"
import EditableCell from "../tables_manager/EditableCell";
import { DateRangeColumnFilter, NumberRangeColumnFilter, SelectColumnFilter } from '../tables_manager/filters';
import Select from 'react-select';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faClipboard, faExternalLinkAlt, faUserCog, faPen, faPhone, faTrash, faEye, faLaptop, faMobileAlt, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import { E_ERROR } from '../../types/errors';
import { useAlert } from "react-alert";
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis'
import ReactTooltip from 'react-tooltip';

const TokenTable = ({ 
  tokensData,
 }: ITokenTable) => {
  const [modal, setModal] = useState(false);
  const [modalToken, setModalToken] = useState('');
  const [copiedFlag, setCopiedFlag] = useState(false);
  const history = useHistory();

  const alert = useAlert();

  const viewCard = (e, id) => {
    if(id !== null && id !== undefined){
      if (e.ctrlKey){
        window.open('/fiche_token/' + id, '_blank');
        return;
      }
      history.push({ pathname: `/fiche_token/${id}` })
    }
    else
      alert.error(E_ERROR.NO_USER_WITH_THIS_ID)
  }

  const handleCopy = (e) => {
    let phone = (e || "").toString().replace(/ /g,'');
    if(phone.length >= 4 && phone[0] !== "0")
      phone = "+" + phone
    alert.info(`Le numéro de téléphone "${phone}" a été copié.`);
    window.navigator.clipboard.writeText(phone);
    setCopiedFlag(true);
    setTimeout(() => setCopiedFlag(false), 2000);
  };
  
  const handleToggle = () => setModal(!modal);

  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        Cell: ({ value }) => {
          return (<a href={value !== null && value !== undefined ? (`/fiche_token/${value}`) : '/#'} onClick={(e) => {
            e.preventDefault();
            if(value !== null && value !== undefined){
              if (e.ctrlKey){
                window.open('/fiche_token/' + value,'_blank');
                return;
              }
              history.push({ pathname: `/fiche_token/${value}` })
            }
            else
              alert.error(E_ERROR.NO_USER_WITH_THIS_ID)
          }}><button className="openLinkBtn">{value}<FontAwesomeIcon icon={faExternalLinkAlt} className="openLinkIcon" /></button></a>)
        },
        hidden: true
      },
      {
        Header: "Propriétaire",
        accessor: "login",
        Cell: ({ value, row: { original } }) => {
          return (<a href={original.user_id !== null && original.user_id !== undefined ? (`/gestion_utilisateur/${original.user_id}`) : '/#'} onClick={(e) => {
            e.preventDefault();
            if(original.user_id !== null && original.user_id !== undefined){
              if (e.ctrlKey){
                window.open('/gestion_utilisateur/' + original.user_id,'_blank');
                return;
              }
              history.push({ pathname: `/gestion_utilisateur/${original.user_id}` })
            }
            else
              alert.error(E_ERROR.NO_USER_WITH_THIS_ID)
          }}><button className="openLinkBtn" title={original.user?.given_name || original.user?.surname ? `${original.user?.surname || ""} ${original.user?.given_name || ""}` : ""}>{value || "-"}<FontAwesomeIcon icon={faExternalLinkAlt} className="openLinkIcon" /></button></a>)
        }
      },
      {
        Header: "Déscription",
        accessor: "name",
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "USER AGENT",
        accessor: "user_agent",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Appareil",
        id: "Appareil",
        accessor: (row, index) => row.on_computer === 1 ? "Ordinateur" : row.on_computer === 0 ? "Téléphone" : "",
        Filter: SelectColumnFilter,
        filter: 'equals',
        className: "text-center",
        Cell: ({ row: {original} }) => original.on_computer === 1 ? <FontAwesomeIcon icon={faLaptop} title="Ordinateur" style={{fontSize: "x-large"}} /> : original.on_computer === 0 ? <FontAwesomeIcon icon={faMobileAlt} title="Téléphone" style={{fontSize: "x-large"}} /> : "-",
        // Cell: ({ value }) => value === 1 ? <FontAwesomeIcon icon={faLaptop} title="Ordinateur" style={{fontSize: "x-large"}} /> : value === 0 ? <FontAwesomeIcon icon={faMobileAlt} title="Téléphone" style={{fontSize: "x-large"}} /> : "-",
      },
      {
        Header: "Appareil professionnel",
        id: "Appareil professionnel",
        accessor: (row, index) => row.pro === 1 ? "Oui" : row.pro === 0 ? "Non" : "",
        Filter: SelectColumnFilter,
        filter: 'equals',
        className: "text-center",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Navigateur",
        accessor: "browser",
        Cell: ({ value }) => value || "-"
      },
      {
        Header: "Résolution",
        accessor: "screen",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Enregistré de",
        accessor: "createdAt",
        customExportDisplay: `$.createdAt ? new Date($.createdAt).toLocaleString('fr') : ""`,
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        // filter: (rows, id, e) => rows.filter(t => t.original[id] && moment(t.original[id]).format('DD/MM/YYYY').includes(e)),
        Cell: ({ value }) => value ? <div title={moment(value).format('DD/MM/YYYY - HH:mm')}>{moment(value).locale('fr').calendar({
            sameDay: '[Aujourd\'hui à] HH:mm',
            nextDay: 'DD/MM/YYYY à HH:mm',
            nextWeek: 'DD/MM/YYYY à HH:mm',
            lastDay: '[Hier à] HH:mm',
            lastWeek: 'DD/MM/YYYY à HH:mm',
            sameElse: 'DD/MM/YYYY à HH:mm'
        })}</div> : "-"
      },
      {
        Header: "Nombre de connexions",
        id: "Nombre de connexions",
        // accessor: "loginlogs_count",
        accessor: (row, index) => row.loginlogs?.length || 0,
        Filter: NumberRangeColumnFilter,
        filter: 'between',
        // filter: (rows, id, e) => rows.filter(t => t.original[id] ? .includes(e)),
        Cell: ({ row: { original } }) => original.loginlogs ? `${original.loginlogs.length} connexion${original.loginlogs.length > 1 ? 's' : ''}` : "-",
      },
      {
        Header: "Dernière activité",
        id: "Dernière activité",
        accessor: (row, index) => {
          if(!row.loginlogs?.length)
            return ""
          return new Date(Math.max(...row.loginlogs.filter(e => !!e.createdAt).map(e => new Date(e.createdAt))))
        },
        // customExportDisplay: `$.createdAt ? new Date($.createdAt).toLocaleString('fr') : ""`,
        Filter: DateRangeColumnFilter,
        filter: "dateBetween",
        // filter: (rows, id, e) => rows.filter(t => t.cells.find(n => n.column?.id === "Dernière activité")?.value && moment(t.cells.find(n => n.column?.id === "Dernière activité").value).format('DD/MM/YYYY').includes(e)),
        sortType: (a, b, id, desc) => a.cells.find(n => n.column?.id === "Dernière activité")?.value > b.cells.find(n => n.column?.id === "Dernière activité")?.value ? 1 : -1,
        disableSortBy: true,
        Cell: ({ value }) => {
          if(!value)
            return "-"
          const now: Date = new Date();
          return <div style={{color: ((now.getTime() - value.getTime()) / (24 * 60 * 60 * 1000)) > 30 ? "red" : ((now.getTime() - value.getTime()) / (24 * 60 * 60 * 1000)) > 7 ? "orangered" : "black"}}>{moment(value).locale('fr').calendar({
              sameDay: '[Aujourd\'hui à] HH:mm',
              nextDay: 'DD/MM/YYYY à HH:mm',
              nextWeek: 'DD/MM/YYYY à HH:mm',
              lastDay: '[Hier à] HH:mm',
              lastWeek: 'DD/MM/YYYY à HH:mm',
              sameElse: 'DD/MM/YYYY à HH:mm'
          })}</div>
        }
      },
      {
        Header: "Autorisé",
        id: "Autorisé",
        accessor: (row, index) => row.allowed === 1 ? "Oui" : row.allowed === 0 ? "Non" : "",
        Filter: SelectColumnFilter,
        filter: 'equals',
        className: "text-center",
        Cell: ({ row: {original} }) => original.allowed === 1 ? <FontAwesomeIcon icon={faCheckCircle} style={{color: "darkgreen", fontSize: "x-large"}} /> : original.allowed === 0 ? <FontAwesomeIcon icon={faTimesCircle} style={{color: "red", fontSize: "x-large"}} /> : "-",
      },
      {
        Header: "Commentaire",
        accessor: "comment",
        Cell: ({ value }) => value || "-",
        hidden: true
      },
      {
        Header: "Action",
        className: "text-center",
        Cell: ({ row }) => (
            <Container className="actionsContainer">
                <button className="btn btn-info btn-rounded btn-sm my-0 waves-effect waves-light"
                  onClick={(e) => viewCard(e, row.original.id)}
                  title="Ouvrir la fiche">
                  <FontAwesomeIcon icon={faEye} />
                </button>
                <button className="btn btn-success btn-rounded btn-sm my-0 waves-effect waves-light actionButtonsSpace"
                  onClick={() => {setModalToken(row.original); setModal(true)}}
                  title="Modifier">
                  <FontAwesomeIcon icon={faPen} />
                </button>
            </Container>
        ),
        disableSortBy: true,
     }
    ],
    []
  );

  return (
    <div>
      <Container>
        <TableContainer columns={columns} data={tokensData} enableCheckBox={false} isEditable={false} SubComponent={({ row }) => <span>SubComponent: {row.id}</span>}/>
      </Container>
      <TokenEdit modal={modal} setModal={setModal} handleToggle={handleToggle} modalToken={modalToken} />
    </div>
  );
};

const mapStateToProps = (state: ITokenTableRedux) => ({
});

export default connect(mapStateToProps, {})(TokenTable);
